import { getInputProps, type FieldMetadata } from "@conform-to/react"
import * as React from "react"

import { cn } from "#app/utils/misc.tsx"

export interface InputProps
	extends React.InputHTMLAttributes<HTMLInputElement> {
	meta: FieldMetadata<string | number | undefined>
	type?: Exclude<
		| "checkbox"
		| "color"
		| "date"
		| "datetime-local"
		| "email"
		| "file"
		| "hidden"
		| "month"
		| "number"
		| "password"
		| "radio"
		| "range"
		| "search"
		| "tel"
		| "text"
		| "time"
		| "url"
		| "week",
		"checkbox" | "radio"
	>
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, type, meta, ...props }, ref) => {
		return (
			<input
				className={cn(
					"flex h-9 w-full rounded-md border border-input bg-white px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
					className,
				)}
				ref={ref}
				{...meta}
				{...getInputProps(meta, {
					type: type ?? "text",
				})}
				{...props}
			/>
		)
	},
)
Input.displayName = "Input"

export { Input }
